import { Button, Form, Image, Input, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "wouter";
import { LoginAdminData } from "../../redux/actions/authActions";
import Alertify from "../../services/alertify";

const { Title } = Typography;

const AdminLogIn = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [, setLocation] = useLocation();
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    const data = {
      email_or_mobile: values.email,
      password: values.password,
    };
    console.log(data);

    dispatch(LoginAdminData(data))
      .then((response) => {
        console.log(response);
        if (response.meta.requestStatus === "fulfilled") {
          setLocation("/admin/order-requests");
        }
      })
      .catch((error) => {
        Alertify.error("Login failed: " + error.message);
      });
  };
  useEffect(() => {
    document.title = "Admin Login: ALP Shop";
  }, []);

  return (
    <div className="grid h-screen place-items-center max-sm:p-4">
      <Form
        layout="vertical"
        className="shadow-2xl p-10 sm:w-1/3 rounded-lg w-full"
        size={"large"}
        onFinish={handleSubmit}
      >
        <Image width={100} src="/assets/alp.svg" preview={false} />
        <Title level={2}>Sign In</Title>
        <Form.Item label="Email Address" name="email">
          <Input type="email" placeholder="Enter Email" />
        </Form.Item>
        <Form.Item label="Password" name="password">
          <Input.Password
            placeholder="Enter Password"
            visibilityToggle={{
              visible: passwordVisible,
              onVisibleChange: setPasswordVisible,
            }}
          />
        </Form.Item>
        <Form.Item>
          <Button className="w-full" type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
        <div className="text-right text-[#0474b8]">
          <Link to="/admin/forgot-password">Forgot password</Link>
        </div>
      </Form>
    </div>
  );
};

export default AdminLogIn;
